import { computed, toRef, type MaybeRefOrGetter } from 'vue'
import type { ServiceType } from '../../Types/service'

export default function useServiceType(existingServiceType: MaybeRefOrGetter<ServiceType | null> = null) {
  const serviceType = toRef(existingServiceType)

  const shouldFillServiceSupplier = computed<boolean>(
    () => true === serviceType.value?.mandatorySupplier && !serviceType.value?.defaultSupplier,
  )

  return {
    // Ref
    serviceType,
    // Computed
    shouldFillServiceSupplier,
  }
}
